export const enum RemoteError {
  unconfirmed = 'UNCONFIRMED',
  unauthorized = 'UNAUTHORIZED',
}
